/**
 * 協定常數。對應 docs/protocol.md。
 * 這些數字是協定的一部分，變更需同步修訂文件。
 */

export const PROTOCOL_VERSION = '0.1'

// §2 路徑語法
export const MAX_PATH_LENGTH = 512
export const MAX_PATH_DEPTH = 16
export const MAX_SEGMENT_LENGTH = 64

// §12 值的限制
export const MAX_PAYLOAD_BYTES = 256 * 1024

// §8.4 寫入逾時
export const DEFAULT_WRITE_TIMEOUT_MS = 5_000
export const MAX_WRITE_TIMEOUT_MS = 60_000

// §9 Action 逾時
export const DEFAULT_CALL_TIMEOUT_MS = 30_000
export const MAX_CALL_TIMEOUT_MS = 300_000

// 風險閘門：等人類確認的時間，比機器對機器的逾時長得多
export const DEFAULT_GATE_TIMEOUT_MS = 120_000
export const MAX_GATE_TIMEOUT_MS = 3_600_000

// §2 根命名空間
export const SYS_ROOT = '$sys'
export const APP_ROOT = 'app'

/** 每個實例由核心建立的節點（相對於 app/{uid}/） */
export const KERNEL_NODE_PATHS = [
  '$meta',
  '$lifecycle',
  '$window/rect',
  '$window/state',
  '$window/z',
] as const
